
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'antd/dist/reset.css';

import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import Questions from './pages/Questions';
import QuestionTypes from './pages/QuestionTypes';
import Login from './pages/Login';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import Footer from './components/Footer';
import PrivateRoute from './components/PrivateRoute';
import Roles from './pages/Roles';
import RoleGroups from './pages/RoleGroups';
import RoleGroupRoles from './pages/RoleGroupRoles';
import QuestionChoices from './pages/QuestionChoices';
import UserManagement from './pages/UserManagement';
import CultureText from './pages/CultureText';
import Cities from './pages/Cities';
import Countries from './pages/Countries';
import Tickets from './pages/Tickets';
import TicketTypes from './pages/TicketTypes';
import TicketStatuses from './pages/TicketStatuses';
import MembershipPackages from './pages/MembershipPackages';
import TagTypes from './pages/TagTypes';
import Tags from './pages/Tags';
import Agreements from './pages/Agreements';


function App() {
  return (
    <Router>
      <ToastContainer position="top-right" autoClose={3000} />

      <Routes>
        <Route path="/login" element={<Login />} />

        <Route element={<PrivateRoute />}>
          <Route
            path="/*"
            element={
              <>
                <Header />
                <div className="d-flex">
                  <Sidebar />
                  <main className="container-fluid p-4">
                    <Routes>
                      <Route path="/" element={<Dashboard />} />
                      <Route path="/users" element={<Users />} />
                      <Route path="/questions" element={<Questions />} />
                      <Route path="/question-types" element={<QuestionTypes />} />
                      <Route path='/tag-types' element={<TagTypes />} />
                      <Route path='/tags' element={<Tags />} />
                      <Route path="/roles" element={<Roles />} />
                      <Route path="/role-groups" element={<RoleGroups />} />
                      <Route path="/role-group-roles" element={<RoleGroupRoles />} />
                      <Route path="/questions/:id/choices" element={<QuestionChoices />} />
                      <Route path='/user-management' element={<UserManagement />} />
                      <Route path='/culture-texts' element={<CultureText />} />
                      <Route path='/cities' element={<Cities />} />
                      <Route path='/countries' element={<Countries />} />
                      <Route path='/tickets' element={<Tickets />} />
                      <Route path='/ticket-types' element={<TicketTypes />} />
                      <Route path='/ticket-statuses' element={<TicketStatuses />} />
                      <Route path='/membership-packages' element={<MembershipPackages />} />
                      <Route path='/agreements' element={<Agreements />} />
                    </Routes>
                  </main>
                </div>
                <Footer />
              </>
            }
          />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;